<script lang="ts" setup>
import JamLoading from '@components/core/JamLoading/JamLoading.vue';
import { useGtag } from '@composables/useGtag';
import { useTheme } from '@composables/useTheme';
import { onMounted } from 'vue';

useTheme();

const { initializeGtagConsent } = useGtag();

onMounted(() => {
  initializeGtagConsent();
});
</script>

<template>
  <router-view v-slot="{ Component }">
    <template v-if="Component">
      <Transition name="fade" mode="out-in">
        <Suspense>
          <component :is="Component" />
          <template #fallback>
            <JamLoading />
          </template>
        </Suspense>
      </Transition>
    </template>
  </router-view>
</template>
